<template>
  <div class="lock-screen-btn-container" @click="onLockScreen">
    <div class="banner-container" @mouseout="out" @mouseover="over">
      <div :class="['banner', {'animate-play': isPlay}]" :style="{left: `-${current * bannerWidth}vw`}">
        <div class="medium-content" v-for="(item, index) in bannerList" :key="index" >
          <render-node :ref="`${item.type + index}`" :file-type="item.type" :url="item.url" />
        </div>
      </div>
    </div>
      <!--        <p class="left" @click="changePage(prevIndex)">&lt;</p>
              <ul>
                <li
                  :class="{ color: index == listIndex }"
                  v-for="(item, index) in list"
                  @click="changePage(index)"
                  :key="index"
                ></li>
              </ul>
              <p class="right" @click="changePage(nextIndex)">&gt;</p>-->
  </div>
</template>

<script>
  import renderNode from './children/render'
  export default {
    name: "lockScreen",
    components: { renderNode },
    data() {
      return {
        isPlay: true,
        bannerWidth: 80,
        current: 0,
        showIndex: 0,
        timer: null,
        bannerList: [
          /*{ type: 'image', duration: 5000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/5.png' },
          { type: 'image', duration: 3000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/02.jpg' },
          { type: 'image', duration: 1000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/03.png' },
          { type: 'video', duration: 10000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/test.mp4' },
          { type: 'image', duration: 5000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/5.png' },*/
        ],
        bannerCount: 0,
        listIndex: 0, //默认显示第几张图片
      }
    },

    computed: {
      //上一张
      prevIndex() {
        if (this.listIndex == 0) {
          return this.list.length - 1;
        } else {
          return this.listIndex - 1;
        }
      },
      //下一张
      nextIndex() {
        if (this.listIndex == this.list.length - 1) {
          return 0;
        } else {
          return this.listIndex + 1;
        }
      },
    },


    mounted() {
      this.getIndustrialComputerAds()
    },

    methods: {

      async getIndustrialComputerAds() {
        const res = await this.$api.getIndustrialComputerAds()
        const {data, level} = res.data
        if (level === 'success') {
          this.bannerList = data.map(item => ({
            type: item['content_type'],
            duration: item.duration * 1000,
            url: this.formatFileURL(item['file']['file_url'])
          }))
          /*this.bannerList = [
            { type: 'image', duration: 5000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/5.png' },
            { type: 'image', duration: 3000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/02.jpg' },
            { type: 'image', duration: 1000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/03.png' },
            { type: 'video', duration: 10000, url: 'https://rzkeji.oss-cn-shenzhen.aliyuncs.com/web/jchelper2021/test/test.mp4' },
          ]*/
          if (this.bannerList.length > 1) {
            this.bannerList.push(this.bannerList[0])
            this.bannerCount = this.bannerList.length
            this.playBanner();
          }
        }
      },


      formatFileURL(url) {
        return url.replace(/http:\/\/127.0.0.1/g, 'http://192.168.0.4:8088')
      },


      changePage(index) {
        this.listIndex = index;
      },


      playBanner() {
        for (const item of Object.values(this.$refs)) {
          item[0].$el.currentTime = 0
          item[0].$el.muted = true
        }

        this.timer = setTimeout(() => {
          this.isPlay = true
          this.current ++
          this.replacementShow()
        }, this.bannerList[this.current].duration)
      },

      replacementShow() {
        setTimeout(() => {
          if (this.current === (this.bannerCount - 1)) {
            this.isPlay = false
            this.current = 0
          }
          clearTimeout(this.timer)
          this.playBanner()
        }, 600)
      },

      //移除
      out() {
        // this.setTimer();
      },
      //移入
      over() {
        // clearInterval(this.timer);
      },

      onLockScreen() {

      },
    },

  };
</script>

<style lang="scss" scoped>
  .lock-screen-btn-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(48, 49, 51, .5);
    z-index: 999999;
    box-sizing: border-box;

    .banner-container {
      $banner-width: 80vw;
      position: relative;
      width: $banner-width;
      height:80vh;
      //background-color: rgba(255,255,255,.9);
      overflow: hidden;

      .banner {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        height: 100%;
        &.animate-play {
          transition: left .6s;
        }

        .medium-content {
          width: $banner-width;
        }
        /*p {
          cursor: pointer;
          color: white;
          font-size: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 50px;
          background: rgba(0, 0, 0, 0.5);

          .left {
            position: absolute;
            top: 50%;
            left: 0;
          }
          .right {
            position: absolute;
            top: 50%;
            right: 0;
          }
          ul {
            list-style: none;
            display: flex;
            justify-content: space-around;
            align-items: center;
            position: absolute;
            width: 150px;
            height: 20px;
            top: 90%;
            right: 35%;
            .color {
              background: red;
              color: red;
            }
            li {
              cursor: pointer;
              width: 10px;
              height: 10px;
              background: white;
              border-radius: 50%;
            }
          }
        }*/
      }
    }
  }
</style>
